import React from "react";
import { Text, TextProps, useMantineTheme } from "@mantine/core";

interface DimmedTextProps extends Omit<TextProps, "size" | "style"> {
  children: React.ReactNode;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  style?: React.CSSProperties;
}

/**
 * DimmedText - Secondary text component with dimmed warm ivory color
 * Usage: <DimmedText>Supporting or secondary text</DimmedText>
 * Forwards Mantine Text props (mb, mt, ta, etc.) via TextProps spread.
 */
export const DimmedText: React.FC<DimmedTextProps> = ({
  children,
  size = "md",
  style,
  ...textProps
}) => {
  const theme = useMantineTheme();
  const other = theme.other as Record<string, string>;

  return (
    <Text
      {...textProps}
      size={size}
      style={{
        color: other.textDimmed,
        lineHeight: 1.6,
        ...style,
      }}
    >
      {children}
    </Text>
  );
};

export default DimmedText;
